import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Quote } from '@viso/web/vendor/shared/models';
import { Response, Environment } from '@viso/core/models';
import { ENVIRONMENT } from '@viso/core/data-access';
import { Discount } from '@viso/web/vendor/shared/models';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class DiscountService {
  constructor(
    private http: HttpClient,
    @Inject(ENVIRONMENT) private environment: Environment
  ) { }

  getDiscount(uuid: string) {
    return this.http.get<Response<Discount>>(`${this.environment.API_URL}/vendor/event-discount/${uuid}`);
  }

  updateDiscount(discount: Discount) {
    return this.http
      .put<Response<Quote>>(`${this.environment.API_URL}/vendor/event-discount/${discount.uuid}`, discount);
  }

}
